<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Risk Assessment
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2 mb-2">
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="method"
                :label="this.localForm.method"
                :items="riskMethodOptions"
                color="wplblue0"
                prepend-icon="troubleshoot"
                hint="assessment method"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.ref"
              :rules="ruleMustBeNotUndefinedANDLessThan50"
              prepend-icon="short_text"
              hint="method ref."
              persistent-hint
              required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-select
              v-model="cause"
              :items="causeOptions"
              :menu-props="{ maxHeight: '400' }"
              label="Select"
              multiple
              prepend-icon="hdr_weak"
              hint="risk causes"
              persistent-hint
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2 mb-2">
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="bars"
                :label="this.localForm.bars"
                :items="riskControlStatusOptions"
                color="wplblue0"
                prepend-icon="shield"
                hint="assessment"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.barr"
              :rules="ruleMustBeNotUndefinedANDLessThan50"
              prepend-icon="short_text"
              hint="barrier"
              persistent-hint
              required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2 mb-2">
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="conts"
                :label="this.localForm.conts"
                :items="riskControlStatusOptions"
                color="wplblue0"
                prepend-icon="health_and_safety"
                hint="assessment"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.contr"
              :rules="ruleMustBeNotUndefinedANDLessThan50"
              prepend-icon="short_text"
              hint="control"
              persistent-hint
              required
              ></v-text-field>
            </v-flex>
          </v-layout>
        </div>
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Risk Managment
            </div>
          </v-layout>

          <v-layout row wrap class="ml-3 mr-2 mt-4">
            <v-flex xs12>
              <v-textarea
              :change="updateFormChar()"
              :color="ui.textColor"
              :background-color="ui.btnColor"
              v-model="localForm.risk"
              :disabled="false"
              :outline="true"
              :rules="ruleMustBeNotUndefinedANDLessThan2000"
              hint="risk barriers and controls"
              auto-grow
              persistent-hint
              ></v-textarea>
            </v-flex>
          </v-layout>
          <v-layout row class="ml-3 mt-3 mr-3">
            <v-chip :color="ui.chipColor" :class="ui.textSubheadingBold">
              Risk Rating
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.chipColor" :class="ui.textSubheading">
              <v-icon left :color="ui.btnColor">
                leaderboard
              </v-icon>
              <div v-if="getRiskAssessmentList.length === null">
                NA
              </div>
              <div v-else>
                {{this.getRiskAssessmentListRiskCounter}}
              </div>
            </v-chip>
            <v-chip :color="ui.chipColor" :class="ui.textSubheading">
              <v-icon left :color="ui.btnColor">emergency</v-icon>
              <div v-if="getRiskAssessmentList.length === null">
                0
              </div>
              <div v-else>
                {{getRiskAssessmentList.length}}
              </div>
            </v-chip>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md6 lg6>
              <DatePicker :date= "{
                obj: 'stats.drev',
                label: dateTypeA(this.getDetailStats.drev),
                hint: 'review date',
                icon: 'today'
                }"
              />
            </v-flex>
            <v-flex xs12 md6>
              <v-select
                :change="updateFormChar()"
                v-model="long"
                :label="this.localForm.long"
                :items="longOptions"
                color="wplblue0"
                prepend-icon="date_range"
                hint="longevity"
                persistent-hint
              >
              </v-select>
            </v-flex>

          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md6>
              <v-select
                :change="updateFormChar()"
                v-model="rec"
                :label="this.localForm.rec"
                :items="riskOutcomeRecommendationOptions"
                color="wplblue0"
                prepend-icon="medication"
                hint="recommendation"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs12 md6>
              <v-select
                :change="updateFormChar()"
                v-model="system"
                :label="this.localForm.system"
                :items="reachBusinessOperationsOptions"
                color="wplblue0"
                prepend-icon="trip_origin"
                hint="systemic risk"
                persistent-hint
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md6>
              <v-select
                :change="updateFormChar()"
                v-model="rate"
                :label="this.localForm.rate"
                :items="riskRanking"
                color="wplblue0"
                prepend-icon="bar_chart"
                hint="current risk"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs12 md6>
              <v-select
                :change="updateFormChar()"
                v-model="outcome"
                :label="this.localForm.outcome"
                :items="riskEvaulationsOptions"
                color="wplblue0"
                prepend-icon="error_outline"
                hint="risk outcome"
                persistent-hint
              >
              </v-select>
            </v-flex>
          </v-layout>
        </div>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import incidentOptions from "@/data/options/mixins/incidentOptions.js";
import safetyOptions from "@/data/options/mixins/safetyOptions.js";
import businessOptions from "@/data/options/mixins/businessOptions.js";
import disciplineOptions from "@/data/options/mixins/disciplineOptions.js";
import riskOptions from "@/data/options/mixins/riskOptions.js";
import DatePicker from "@/data/functions/components/DatePicker";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      ctr: 0,
      localForm: {
        cause: "",
        method: "",
        risk: "",
        rec: "",
        outcome: "",
        system: "",
        bars: "",
        barr: "",
        conts: "",
        contr: "",
        ref: "",
        long: "",
        rate: ""
      },
      orgForm: {
        cause: "",
        method: "",
        risk: "",
        rec: "",
        outcome: "",
        system: "",
        bars: "",
        barr: "",
        conts: "",
        contr: "",
        ref: "",
        long: "",
        rate: ""
      },
      long: "",
      bars: "",
      conts: "",
      cause: "",
      outcome: "",
      method: "",
      other: "", // potential impact
      rec: "",
      system: "",
      rate: ""
    };
  },
  components: {
    DatePicker
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.method = this.getDetail.char.method;
    this.localForm.outcome = this.getDetail.char.outcome;
    this.localForm.risk = this.getDetail.char.risk;
    this.localForm.rec = this.getDetail.char.rec;
    this.localForm.system = this.getDetail.char.system;
    this.localForm.bars = this.getDetail.char.bars;
    this.localForm.conts = this.getDetail.char.conts;
    this.localForm.barr = this.getDetail.char.barr;
    this.localForm.contr = this.getDetail.char.contr;
    this.localForm.ref = this.getDetail.char.ref;
    this.localForm.long = this.getDetail.char.long;
    this.localForm.rate = this.getDetail.char.rate;

    this.orgForm.outcome = this.getDetail.char.outcome;
    this.orgForm.method = this.getDetail.char.method;
    this.orgForm.risk = this.getDetail.char.risk;
    this.orgForm.rec = this.getDetail.char.rec;
    this.orgForm.system = this.getDetail.char.system;
    this.orgForm.bars = this.getDetail.char.bars;
    this.orgForm.conts = this.getDetail.char.conts;
    this.orgForm.barr = this.getDetail.char.barr;
    this.orgForm.contr = this.getDetail.char.contr;
    this.orgForm.ref = this.getDetail.char.ref;
    this.orgForm.long = this.getDetail.char.long;
    this.orgForm.rate = this.getDetail.char.rate;

    this.cause = this.getDetailRelps.s7;
  },
  watch: {
    cause() {
      this.localForm.cause = this.cause;
      this.updateFormRelps();
    },
    outcome() {
      this.localForm.outcome = this.outcome;
      this.updateFormChar();
    },
    method() {
      this.localForm.method = this.method;
      this.updateFormChar();
    },
    rec() {
      this.localForm.rec = this.rec;
      this.updateFormChar();
    },
    system() {
      this.localForm.system = this.system;
      this.updateFormChar();
    },
    bars() {
      this.localForm.bars = this.bars;
      this.updateFormChar();
    },
    conts() {
      this.localForm.conts = this.conts;
      this.updateFormChar();
    },
    long() {
      this.localForm.long = this.long;
      this.updateFormChar();
    },
    rate() {
      this.localForm.rate = this.rate;
      this.updateFormChar();
    }
  },
  // eslint-disable-next-line
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    incidentOptions,
    disciplineOptions,
    safetyOptions,
    riskOptions,
    dateFunctions,
    businessOptions
  ],
  computed: {
    ...mapGetters([
      "getDetail",
      "getDetailChar",
      "getDetailRelps",
      "getDetailStats",
      "getCurrentPage",
      "getRiskAssessmentList",
      "getRiskAssessmentListRiskCounter"
    ])
  },
  methods: {
    updateFormRelps() {
      let relps = this.getDetailRelps;
      relps.s7 = this.cause;
      if (this.ctr > 1) {
        this.$store.dispatch("changeDataSavePendingIndication", true);
        this.$store.dispatch("changeDetailRelps", relps);
        this.saveDocumentRevMod(4.17, 1); // business mod.
      }
      // This conter ensure that the Hazard Contrl does not fire
      //  in the first page show
      this.ctr = this.ctr + 1;
    },
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line
      if (
        this.localForm.method !== this.orgForm.method &&
        this.localForm.method !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.method = this.localForm.method;
        // basic
        char.method = this.localForm.method;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.bars !== this.orgForm.bars &&
        this.localForm.bars !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.bars = this.localForm.bars;
        // basic
        char.bars = this.localForm.bars;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 3); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.barr !== this.orgForm.barr &&
        this.localForm.barr !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.barr = this.localForm.barr;
        // basic
        char.barr = this.localForm.barr;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 4); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.conts !== this.orgForm.conts &&
        this.localForm.conts !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.conts = this.localForm.conts;
        // basic
        char.conts = this.localForm.conts;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.contr !== this.orgForm.contr &&
        this.localForm.contr !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.contr = this.localForm.contr;
        // basic
        char.contr = this.localForm.contr;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 6); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.outcome !== this.orgForm.outcome &&
        this.localForm.outcome !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.outcome = this.localForm.outcome;
        // basic
        char.outcome = this.localForm.outcome;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 7); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.risk !== this.orgForm.risk &&
        this.localForm.risk !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.risk = this.localForm.risk;
        // basic
        char.risk = this.localForm.risk;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 8); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.system !== this.orgForm.system &&
        this.localForm.system !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.system = this.localForm.system;
        // basic
        char.system = this.localForm.system;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 9); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.rec !== this.orgForm.rec &&
        this.localForm.rec !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.rec = this.localForm.rec;
        // basic
        char.rec = this.localForm.rec;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 10); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.ref !== this.orgForm.ref &&
        this.localForm.ref !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.ref = this.localForm.ref;
        // basic
        char.ref = this.localForm.ref;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 11); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.long !== this.orgForm.long &&
        this.localForm.long !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.long = this.localForm.long;
        // basic
        char.long = this.localForm.long;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 12); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.rate !== this.orgForm.rate &&
        this.localForm.rate !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.rate = this.localForm.rate;
        // basic
        char.rate = this.localForm.rate;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 13); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
